import { render, staticRenderFns } from "./employee-search.vue?vue&type=template&id=0052811a&scoped=true&"
import script from "./employee-search.component.ts?vue&type=script&lang=ts&"
export * from "./employee-search.component.ts?vue&type=script&lang=ts&"
import style0 from "./employee-search.vue?vue&type=style&index=0&id=0052811a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0052811a",
  null
  
)

export default component.exports